import { Routes } from '@angular/router';
import { ContentComponent } from './layout/content/content.component';
import { AuthGuard } from './authentication/auth-guard';
import { AccessDeniedComponent } from './layout/access-denied/access-denied.component';


export const routes: Routes = [
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: '',
    loadComponent: () =>
      import('./modules/auth/login/login.component').then(
        (i) => i.LoginComponent
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./modules/auth/login/login.component').then(
        (i) => i.LoginComponent
      ),
  },
  {
    path: '',
    component: ContentComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'instance-management',
        canActivate: [AuthGuard],
        data: { roles: ['SA'] },
        loadComponent: () =>
          import(
            './modules/super-admin/instance-management/instance-management.component'
          ).then((i) => i.InstanceManagementComponent),
      },
      {
        path: 'user-management',
        canActivate: [AuthGuard],
        data: { roles: ['SA','admin'] },
        loadComponent: () =>
          import(
            './modules/super-admin/user-management/user-management.component'
          ).then((i) => i.UserManagementComponent),
      },
      {
        path: 'location-management',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/location-management/location-management.component'
          ).then((i) => i.LocationManagementComponent),
      },
      {
        path: 'ecg-records',
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'hospitalUser'] },
        loadComponent: () =>
          import(
            './modules/admin/ecg-records/ecg-records.component'
          ).then((i) => i.EcgRecordsComponent),
      },
      {
        path: 'hospital-management',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/hospital-management/hospital-list/hospital-management.component'
          ).then((i) => i.HospitalManagementComponent),
      },
      {
        path: 'hospital-management-create',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/hospital-management/hospital-create/hospital-management-create.component'
          ).then((i) => i.HospitalManagementCreateComponent),
      },
      {
        path: 'hospital-management-edit/:id',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/hospital-management/hospital-create/hospital-management-create.component'
          ).then((i) => i.HospitalManagementCreateComponent),
      },
      {
        path: 'hospital-view/:id',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/hospital-management/hospital-view/hospital-view.component'
          ).then((i) => i.HospitalViewComponent),
      },
      {
        path: 'cluster-management',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/cluster-management/cluster-list/cluster-list.component'
          ).then((i) => i.ClusterListComponent),
      },
      {
        path: 'cluster-mapping',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/cluster-mapping/cluster-mapping.component'
          ).then((i) => i.ClusterMappingComponent),
      },
      {
        path: 'control-panel',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/control-panel/control-panel.component'
          ).then((i) => i.ControlPanelComponent),
      },
      {
        path: 'patient-list',
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'hospitalUser', 'locationUser', 'clusterUser'] },
        loadComponent: () =>
          import(
            './modules/admin/patient-management/patient-list/patient-list.component'
          ).then((i) => i.PatientListComponent),
      },
      {
        path: 'patient-form/:category',
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'hospitalUser', 'locationUser', 'clusterUser'] },
        loadComponent: () =>
          import(
            './modules/admin/patient-management/patient-layout/patient-form/patient-form.component'
          ).then((i) => i.PatientFormComponent),
      },
    /*  {
        path: 'patient-management/:category/:id/:mode',
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'hospitalUser'] },
        loadComponent: () =>
          import(
            './modules/admin/patient-management/patient-edit/patient-management.component'
          ).then((i) => i.PatientManagementComponent),
      },
      {
        path: 'patient-management/:categoryName',
        canActivate: [AuthGuard],
        data: { roles: ['hospitalUser'] },
        loadComponent: () =>
          import(
            './modules/admin/patient-management/patient-edit/patient-management.component'
          ).then((i) => i.PatientManagementComponent),
      },*/


      {
        path: 'patient-print/:id',
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'hospitalUser'] },
        loadComponent: () =>
          import(
            './modules/admin/patient-management/patient-print/patient-print.component'
          ).then((i) => i.PatientPrintComponent),
      },
      {
        path: 'device-management',
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import(
            './modules/admin/device-management/device-management.component'
          ).then((i) => i.DeviceManagementComponent),
      },
    ],
  },
];
